import { createContext, useContext } from 'react'

/** True when `UploadedFile` is in the full Uploads panel grid (hover checkbox + bulk delete). */
export const UploadsPanelUploadsListContext = createContext(false)

export const useUploadsPanelUploadsList = () => useContext(UploadsPanelUploadsListContext)
